import {ToastHandler} from "./toast-handler";

export class ToastQueue {
    private _queue: ToastHandler[] = [];

    addToQueue(handler: ToastHandler) {
        // Behavior 1: Add to queue only if the ID doesn't exists
        let existingToast = this._queue.find((t) => t.toastId === handler.toastId);
        if (!existingToast) {
            this._queue.push(handler);
        }
        // OR
        // Behavior 2: Remove the existing one if exists and add the new one AT THE END OF THE LIST (update)
        // let existingToastIndex = this._queue.findIndex((t) => t.toastId === handler.toastId);
        // if (existingToastIndex !== -1) {
        //     this._queue.splice(existingToastIndex, 1);
        // }
        // this._queue.push(handler);
        // OR
        // Behavior 3: Remove the existing one if exists and add the new one AT THE ORIGINAL POSITION (update)
        // let existingToastIndex = this._queue.findIndex((t) => t.toastId === handler.toastId);
        // if (existingToastIndex !== -1) {
        //     this._queue.splice(existingToastIndex, 1, handler);
        // }
        // OR
        // Behavior 4: Just add to queue, no checking
        // this._queue.push(handler);
    }

    processQueue = () => {
        while (this._queue.length > 0) {
            const toastHandler = this._queue.shift();
            toastHandler.show();
        }
    }

    clearQueue() {
        this._queue = [];
    }
}